
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * SymbolDayProfitLossInfoNotify struct
 */
class SymbolDayProfitLossInfoNotify {
  /**
   * Initialize struct
   * @param {!number=} dayProfitLoss
   * @constructor
   */
  constructor (dayProfitLoss = 0.0) {
    this.DayProfitLoss = dayProfitLoss
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SymbolDayProfitLossInfoNotify}
   * @param {!SymbolDayProfitLossInfoNotify} other Other struct
   * @returns {!SymbolDayProfitLossInfoNotify} This struct
   */
  copy (other) {
    if (other.DayProfitLoss != null) {
      this.DayProfitLoss = other.DayProfitLoss
    } else {
      this.DayProfitLoss = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SymbolDayProfitLossInfoNotify}
   * @returns {!SymbolDayProfitLossInfoNotify} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SymbolDayProfitLossInfoNotifyModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SymbolDayProfitLossInfoNotifyModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SymbolDayProfitLossInfoNotify}
   * @param {!SymbolDayProfitLossInfoNotify} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SymbolDayProfitLossInfoNotify)) {
      throw new TypeError('Instance of SymbolDayProfitLossInfoNotify is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SymbolDayProfitLossInfoNotify}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      DayProfitLoss: ((this.DayProfitLoss != null) ? this.DayProfitLoss : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SymbolDayProfitLossInfoNotify.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SymbolDayProfitLossInfoNotify} other Object value
   * @returns {!SymbolDayProfitLossInfoNotify} Created struct
   */
  static fromObject (other) {
    return new SymbolDayProfitLossInfoNotify().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SymbolDayProfitLossInfoNotify}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SymbolDayProfitLossInfoNotify.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SymbolDayProfitLossInfoNotify}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5170
  }
}

export { SymbolDayProfitLossInfoNotify };

/**
 * Fast Binary Encoding SymbolDayProfitLossInfoNotify field model
 */
class FieldModelSymbolDayProfitLossInfoNotify extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.DayProfitLoss = new fbe.FieldModelDouble(buffer, 4 + 4)
  }

  /**
   * Get the field size
   * @this {!FieldModelSymbolDayProfitLossInfoNotify}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSymbolDayProfitLossInfoNotify}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.DayProfitLoss.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSymbolDayProfitLossInfoNotify}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.DayProfitLoss.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSymbolDayProfitLossInfoNotify}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSymbolDayProfitLossInfoNotify.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSymbolDayProfitLossInfoNotify}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5170
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSymbolDayProfitLossInfoNotify}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSymbolDayProfitLossInfoNotify}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.DayProfitLoss.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DayProfitLoss.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DayProfitLoss.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSymbolDayProfitLossInfoNotify}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSymbolDayProfitLossInfoNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSymbolDayProfitLossInfoNotify}
   * @param {!SymbolDayProfitLossInfoNotify} fbeValue Default value, defaults is new SymbolDayProfitLossInfoNotify()
   * @returns {!SymbolDayProfitLossInfoNotify} SymbolDayProfitLossInfoNotify value
   */
  get (fbeValue = new SymbolDayProfitLossInfoNotify()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSymbolDayProfitLossInfoNotify}
   * @param {!SymbolDayProfitLossInfoNotify} fbeValue SymbolDayProfitLossInfoNotify value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.DayProfitLoss.fbeSize) <= fbeStructSize) {
      fbeValue.DayProfitLoss = this.DayProfitLoss.get()
    } else {
      fbeValue.DayProfitLoss = 0.0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DayProfitLoss.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSymbolDayProfitLossInfoNotify}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSymbolDayProfitLossInfoNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSymbolDayProfitLossInfoNotify}
   * @param {!SymbolDayProfitLossInfoNotify} fbeValue SymbolDayProfitLossInfoNotify value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSymbolDayProfitLossInfoNotify}
   * @param {SymbolDayProfitLossInfoNotify} fbeValue SymbolDayProfitLossInfoNotify value
   */
  setFields (fbeValue) {
    this.DayProfitLoss.set(fbeValue.DayProfitLoss)
  }
}

export { FieldModelSymbolDayProfitLossInfoNotify };

/**
 * Fast Binary Encoding SymbolDayProfitLossInfoNotify model
 */
class SymbolDayProfitLossInfoNotifyModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSymbolDayProfitLossInfoNotify(this.buffer, 4)
  }

  /**
   * Get the SymbolDayProfitLossInfoNotify model
   * @this {!SymbolDayProfitLossInfoNotifyModel}
   * @returns {!FieldModelSymbolDayProfitLossInfoNotify} model SymbolDayProfitLossInfoNotify model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SymbolDayProfitLossInfoNotifyModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SymbolDayProfitLossInfoNotifyModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SymbolDayProfitLossInfoNotifyModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SymbolDayProfitLossInfoNotifyModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSymbolDayProfitLossInfoNotify.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SymbolDayProfitLossInfoNotifyModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SymbolDayProfitLossInfoNotifyModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SymbolDayProfitLossInfoNotifyModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SymbolDayProfitLossInfoNotifyModel}
   * @param {!SymbolDayProfitLossInfoNotify} value SymbolDayProfitLossInfoNotify value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SymbolDayProfitLossInfoNotifyModel}
   * @param {!SymbolDayProfitLossInfoNotify} value SymbolDayProfitLossInfoNotify value, defaults is new SymbolDayProfitLossInfoNotify()
   * @return {!object} Deserialized SymbolDayProfitLossInfoNotify value and its size
   */
  deserialize (value = new SymbolDayProfitLossInfoNotify()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SymbolDayProfitLossInfoNotify(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SymbolDayProfitLossInfoNotify(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SymbolDayProfitLossInfoNotifyModel}
   * @param {!number} prev Previous SymbolDayProfitLossInfoNotify model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SymbolDayProfitLossInfoNotifyModel };
